export const PLAYERS_PER_PAGE = 15;
export const PLAYER_SCORES_PER_PAGE = 10;
export const LEADERBOARD_SCORES_PER_PAGE = 10;
